var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 387.224,
    height: 383.38,
    viewBox: "0 0 387.224 383.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.876 95.142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3631.877,477.257c-6.467-25.676-17.752-48.626-31.787-64.658a87.242,87.242,0,0,1-21.581-61.1c1.748-45.026,38.369-81.918,83.368-83.992a87.554,87.554,0,0,1,71.047,143.926l-.442.522c-16.043,18.987-26.642,31.532-32.166,53.462l-.2.786a11.714,11.714,0,1,1-22.716-5.735l.2-.779c6.846-27.182,20.147-42.923,36.988-62.854l.441-.522a64.135,64.135,0,1,0-97.309.856c16.428,18.767,29.523,45.166,36.869,74.333l-11.338,2.943Z",
    transform: "translate(-3578.442 -267.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3626.384,442.129a11.717,11.717,0,0,1-3.241-22.973l38.507-11.109a11.715,11.715,0,1,1,6.494,22.511l-38.507,11.109A11.747,11.747,0,0,1,3626.384,442.129Z",
    transform: "translate(-3558.081 -188.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3626.106,464.374a11.717,11.717,0,0,1-3.244-22.974l38.508-11.109a11.715,11.715,0,0,1,6.495,22.511l-38.505,11.109A11.751,11.751,0,0,1,3626.106,464.374Z",
    transform: "translate(-3558.238 -176.135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3638.828,279.916a11.715,11.715,0,0,1-11.716-11.715V218.215a11.715,11.715,0,0,1,23.43,0V268.2A11.713,11.713,0,0,1,3638.828,279.916Z",
    transform: "translate(-3445.215 -206.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3572.36,346.383h-49.986a11.715,11.715,0,0,1,0-23.43h49.986a11.715,11.715,0,0,1,0,23.43Z",
    transform: "translate(-3510.66 -141.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3773.265,346.383h-49.987a11.715,11.715,0,0,1,0-23.43h49.987a11.715,11.715,0,0,1,0,23.43Z",
    transform: "translate(-3397.756 -141.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3556.483,441.443a11.714,11.714,0,0,1-8.285-20l35.346-35.346a11.715,11.715,0,0,1,16.567,16.568l-35.345,35.346A11.681,11.681,0,0,1,3556.483,441.443Z",
    transform: "translate(-3491.492 -107.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3698.542,299.383a11.714,11.714,0,0,1-8.285-20l35.346-35.346a11.716,11.716,0,1,1,16.57,16.568l-35.346,35.346A11.685,11.685,0,0,1,3698.542,299.383Z",
    transform: "translate(-3411.657 -187.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3591.83,299.383a11.686,11.686,0,0,1-8.285-3.43L3548.2,260.607a11.715,11.715,0,1,1,16.568-16.568l35.345,35.346a11.714,11.714,0,0,1-8.281,20Z",
    transform: "translate(-3491.492 -187.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3733.888,441.443a11.683,11.683,0,0,1-8.284-3.43l-35.346-35.346a11.716,11.716,0,0,1,16.57-16.568l35.346,35.346a11.714,11.714,0,0,1-8.286,20Z",
    transform: "translate(-3411.657 -107.497)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1d3e69020508e8cd4a7b7c66f7b1a00.svg";
export { ForwardRef as ReactComponent };